import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VehiclesAddDispatcher } from '@spaq/core/dispatchers/vehicles-add-dispatcher';
import { VehiclesDetailsDispatcher } from '@spaq/core/dispatchers/vehicles-details-dispatcher';
import { VehiclesDispatcher } from '@spaq/core/dispatchers/vehicles-dispatcher';
import { VehiclesEditDispatcher } from '@spaq/core/dispatchers/vehicles-edit-dispatcher';
import { VehiclesFormDispatcher } from '@spaq/core/dispatchers/vehicles-form-dispatcher';
import {
	VEHICLES_ADD_DISPATCHER,
	VEHICLES_ADD_STORE,
	VEHICLES_DETAILS_DISPATCHER,
	VEHICLES_DETAILS_STORE,
	VEHICLES_DISPATCHER,
	VEHICLES_EDIT_DISPATCHER,
	VEHICLES_EDIT_STORE,
	VEHICLES_FORM_DISPATCHER,
	VEHICLES_FORM_STORE,
	VEHICLES_STORE
} from '@spaq/injection';
import { PopupModule } from '@spaq/modules/popup';
import { FormModule } from '@spaq/shared/components/forms';
import { SharedCommonModule } from '@spaq/shared/shared-common.module';
import { SharedComponentsModule } from '@spaq/shared/shared-components.module';
import { SharedFormModule } from '@spaq/shared/shared-form.module';

import { VehiclesAddStore } from '@spaq/core/stores/vehicles-add-store';
import { VehiclesDetailsStore } from '@spaq/core/stores/vehicles-details-store';
import { VehiclesEditStore } from '@spaq/core/stores/vehicles-edit-store';
import { VehiclesFormStore } from '@spaq/core/stores/vehicles-form-store';
import { VehiclesStore } from '@spaq/core/stores/vehicles-store';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { VehiclesModule as SharedVehiclesModule } from '@shared/modules';
import { AddVehicleComponent, FieldsetVehicleComponent, VehicleItemComponent } from './components';
import { VehiclesAddComponent, VehiclesComponent, VehiclesEditComponent, VehiclesPageComponent } from './pages';

@NgModule({
	imports: [
		SharedCommonModule,
		DropDownsModule,
		SharedComponentsModule,
		RouterModule,
		FormModule,
		SharedFormModule,
		PopupModule,
		SharedVehiclesModule
	],
	declarations: [
		VehiclesPageComponent,
		VehicleItemComponent,
		VehiclesEditComponent,
		FieldsetVehicleComponent,
		VehiclesAddComponent,
		AddVehicleComponent,
		VehiclesComponent
	],
	exports: [
		VehiclesPageComponent,
		VehicleItemComponent,
		VehiclesEditComponent,
		FieldsetVehicleComponent,
		VehiclesAddComponent,
		AddVehicleComponent,
		SharedVehiclesModule,
		VehiclesComponent,
		PopupModule
	]
})
export class VehiclesModule {
	static forRoot(): ModuleWithProviders<VehiclesModule> {
		return {
			ngModule: VehiclesModule,
			providers: [
				{ provide: VEHICLES_STORE, useClass: VehiclesStore },
				{ provide: VEHICLES_EDIT_STORE, useClass: VehiclesEditStore },
				{ provide: VEHICLES_ADD_STORE, useClass: VehiclesAddStore },
				{ provide: VEHICLES_DETAILS_STORE, useClass: VehiclesDetailsStore },
				{ provide: VEHICLES_DISPATCHER, useClass: VehiclesDispatcher },
				{ provide: VEHICLES_EDIT_DISPATCHER, useClass: VehiclesEditDispatcher },
				{ provide: VEHICLES_ADD_DISPATCHER, useClass: VehiclesAddDispatcher },
				{ provide: VEHICLES_DETAILS_DISPATCHER, useClass: VehiclesDetailsDispatcher },
				{ provide: VEHICLES_FORM_DISPATCHER, useClass: VehiclesFormDispatcher },
				{ provide: VEHICLES_FORM_STORE, useClass: VehiclesFormStore }
			]
		};
	}
}
